import { Outlet } from "react-router-dom";
import Header from "./Header/Header";
import VerticalMenu from "./LeftMenu/VerticalMenu";
import { useEffect, useState } from "react";

const Main = () => {
  const [collapsed, setCollapsed] = useState(
    localStorage.getItem("sidebar_collapsed") === "true",
  );

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    window.onpopstate = () => {
      window.history.pushState(null, "", window.location.href);
    };
  }, []);

  const toggleSidebar = () => {
    const value = !collapsed;

    setCollapsed(value);

    localStorage.setItem("sidebar_collapsed", String(value));
  };

  return (
    <div
      id="main-app"
      className={`layout-veritcle-menu ${collapsed ? "sidebar-collapsed" : ""}`}
    >
      <VerticalMenu collapsed={collapsed} toggleSidebar={toggleSidebar} />

      <div className="app-body">
        <Header collapsed={collapsed} toggleSidebar={toggleSidebar} />

        <div className="app-page">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Main;
